import { useState, useEffect, useRef, useCallback } from "react";
import Layout from "../../layout/Layout";
import OrderPlaced from "../../components/Icon/OrderPlaced";
import OrderConfirmed from "../../components/Icon/OrderConfirmed";
import OrderPreparing from "../../components/Icon/OrderPreparing";
import OutForDelivery from "../../components/Icon/OutForDelivery";
import OrderDelivered from "../../components/Icon/OrderDelivered";
import TrackOrderId from "../../components/Icon/TrackOrderId";
import TrackPaymentMode from "../../components/Icon/TrackPaymentMode";
import { useNavigate, useLocation, json, useParams } from "react-router-dom";
import { setProgressData } from "../../store/progressData/progressDataSlice";
import { useSelector, useDispatch } from "react-redux";
import { useProgress } from "../../hooks/useProgress";
import { getStoreData, orderStatus, viewStatus } from "../../services";
import TrackFoodLoader from "../../components/Loader/TrackFoodLoader";
import TrackMap from "../../components/Elements/TrackMap";
import OrderModal from "../../components/Modal/OrderModal";

import {
  prepareAddressFormat,
  checkEmpty,
  prepareOrderTracing,
  addLeadingZero,
} from "../../utils/helper";
import { removeAllSpaceFromString } from "../../utils";
import { setStoreDetails } from "../../store/basicData/basicDataSlice";

const TrackFood = () => {
  const navigate = useNavigate();
  const [currentStep, setCurrentStep] = useState(0);
  const NUMBER_OF_STEPS = 5;
  const { id } = useParams();
  const [isLoader1, setIsLoader1] = useState(true);
  const [isLoader2, setIsLoader2] = useState(true);
  const [orderDetails, setOrderDetails] = useState("");
  const [basketStoreDetails, setBasketStoreDetails] = useState("");
  const [status, setStatus] = useState({});
  const websiteColor = useSelector((state) => state?.onLoadData?.color);

  const dispatch = useDispatch();
  const { progressFunction } = useProgress();
  const [intervalData, setintervalData] = useState(0);
  const [orderType, setorderType] = useState("");
  const [orderProcessing, setorderProcessing] = useState(0);

  const [pathCoordinates, setpathCoordinates] = useState([
    { lat: "", lng: "", name: "" },
    { lat: "", lng: "", name: "" },
  ]);
  const [start, setstart] = useState({
    lat: "",
    lng: "",
    name: "",
  });
  const [end, setend] = useState({
    lat: "",
    lng: "",
    name: "",
  });
  const [defaultCenter, setdefaultCenter] = useState({
    lat: "",
    lng: "",
  });

  useEffect(() => {
    if (isLoader1) {
      let count = 0;
      const intervalVariable = setInterval(() => {
        if (count < 90) {
          dispatch(setProgressData(count));
        } else if (count >= 90) {
          dispatch(setProgressData(90));
          window.clearInterval(intervalVariable);
        }
        count = count + 10;
      }, 10);

      setintervalData(intervalVariable);
      progressFunction(intervalVariable);
    } else {
      dispatch(setProgressData(100));
      window.clearInterval(intervalData);
    }
  }, [isLoader1]);

  useEffect(() => {
    getpageContent();
    getorderTracing();
    handleViewOrder();
  }, []);

  const toggleDrawer = () => {};

  const handleViewOrder = async () => {
    const basketKey = id;
    setIsLoader1(false);
    try {
      const { status, data } = await viewStatus(basketKey);
      if (status === 200) {
        if (data.status === "success") {
          dispatch(setStoreDetails(data?.storedetails));
          setOrderDetails(data?.basket);
          setBasketStoreDetails(data?.storedetails);
        }
        setIsLoader1(false);
      }
    } catch (e) {
      setIsLoader1(false);
      error("error msg");
    } finally {
      setIsLoader1(false);
    }
  };

  const getpageContent = async () => {
    setIsLoader1(true);

    const { status, data } = await getStoreData("", "", "OrderStatus");
    if (status === 200) {
      setIsLoader1(false);
    } else {
      setIsLoader1(false);

      throw new Error("Something went wrong!! Please try again");
    }
  };

  const getorderTracing = async () => {
    setIsLoader2(true);
    const { status, data } = await orderStatus(id);
    if (status === 200) {
      setStatus(data);
      setIsLoader2(false);
      setorderType(data?.basket?.pos_basket_Delivery_Type);
      setorderProcessing(
        prepareOrderTracing(
          data?.orderStatus,
          data?.basket?.pos_basket_Delivery_Type
        )
      );
      if (data?.basket?.pos_basket_Delivery_Type == "Delivery") {
        let pathCoordinatesArrray = [];
        pathCoordinatesArrray.push({
          lat: Number(data?.storedetails?.store_Latitude),
          lng: Number(data?.storedetails?.store_Longitude),
          name: prepareAddressFormat(
            data?.storedetails?.store_Address_Line_1,
            data?.storedetails?.store_Address_Line_2,
            "",
            removeAllSpaceFromString(data?.storedetails?.store_Postcode)
          ),
        });
        pathCoordinatesArrray.push({
          lat: Number(data?.basket?.pos_basket_Customer_Billing_Latitude),
          lng: Number(data?.basket?.pos_basket_Customer_Billing_Longitude),
          name: prepareAddressFormat(
            data?.basket?.pos_basket_Customer_Billing_Address_Line_1,
            data?.basket?.pos_basket_Customer_Billing_Address_Line_2,
            "",
            removeAllSpaceFromString(
              data?.basket?.pos_basket_Customer_Billing_Postcode
            )
          ),
        });
        setpathCoordinates(pathCoordinatesArrray);
        setstart(pathCoordinatesArrray[0]);
        setend(pathCoordinatesArrray[1]);

        if (
          !checkEmpty(pathCoordinatesArrray[1]) &&
          Number(data?.basket?.pos_basket_Customer_Billing_Latitude) != 0 &&
          Number(data?.basket?.pos_basket_Customer_Billing_Longitude) != 0 &&
          !checkEmpty(pathCoordinatesArrray[0]) &&
          Number(data?.storedetails?.store_Latitude) != 0 &&
          Number(data?.storedetails?.store_Longitude) != 0
        ) {
          let defaultArray = {
            lat:
              (data?.storedetails?.store_Latitude * 1.0 +
                data?.basket?.pos_basket_Customer_Billing_Latitude * 1.0) /
              2.0,
            lng:
              (data?.storedetails?.store_Longitude * 1.0 +
                data?.basket?.pos_basket_Customer_Billing_Longitude * 1.0) /
              2.0,
          };
          setdefaultCenter(defaultArray);
        } else if (
          !checkEmpty(pathCoordinatesArrray[1]) &&
          Number(data?.basket?.pos_basket_Customer_Billing_Latitude) != 0 &&
          Number(data?.basket?.pos_basket_Customer_Billing_Longitude) != 0
        ) {
          let defaultArray = {
            lat: Number(data?.basket?.pos_basket_Customer_Billing_Latitude),
            lng: Number(data?.basket?.pos_basket_Customer_Billing_Longitude),
          };
          setdefaultCenter(defaultArray);
        } else if (
          !checkEmpty(pathCoordinatesArrray[0]) &&
          Number(data?.storedetails?.store_Latitude) != 0 &&
          Number(data?.storedetails?.store_Longitude) != 0
        ) {
          let defaultArray = {
            lat: Number(data?.storedetails?.store_Latitude),
            lng: Number(data?.storedetails?.store_Longitude),
          };
          setdefaultCenter(defaultArray);
        } else {
          let defaultArray = {
            lat: 53.0,
            lng: -2.179404,
          };

          setdefaultCenter(defaultArray);
        }

        // setSelectedStartLocation(pathCoordinatesArrray[0]);
        // setSelectedEndLocation(pathCoordinatesArrray[1]);
      } else {
        let pathCoordinatesArrray = [];

        pathCoordinatesArrray.push({
          lat: Number(data?.storedetails?.store_Latitude),
          lng: Number(data?.storedetails?.store_Longitude),
          name: prepareAddressFormat(
            data?.storedetails?.store_Address_Line_1,
            data?.storedetails?.store_Address_Line_2,
            "",
            removeAllSpaceFromString(data?.storedetails?.store_Postcode)
          ),
        });

        setpathCoordinates(pathCoordinatesArrray);
        setstart(pathCoordinatesArrray[0]);
        setend(pathCoordinatesArrray[1]);

        if (
          !checkEmpty(pathCoordinatesArrray[0]) &&
          Number(data?.storedetails?.store_Latitude) != 0 &&
          Number(data?.storedetails?.store_Longitude) != 0
        ) {
          let defaultArray = {
            lat: Number(data?.storedetails?.store_Latitude),
            lng: Number(data?.storedetails?.store_Longitude),
          };
          setdefaultCenter(defaultArray);
        } else {
          let defaultArray = {
            lat: 53.0,
            lng: -2.179404,
          };

          setdefaultCenter(defaultArray);
        }

        // setSelectedStartLocation(pathCoordinatesArrray[0]);
        // setSelectedEndLocation(pathCoordinatesArrray[1]);
      }
    } else {
      setIsLoader2(false);
      throw new Error("Something went wrong!! Please try again");
    }
  };

  const goToNextStep = () =>
    setCurrentStep((prev) => (prev === NUMBER_OF_STEPS - 1 ? prev : prev + 1));
  const goToPreviousStep = () =>
    setCurrentStep((prev) => (prev <= 0 ? prev : prev - 1));

  const startIcon = {
    url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='6' fill='%2305B011'/%3E%3Ccircle cx='10' cy='10' r='9' stroke='%2305B011' strokeWidth='2'/%3E%3C/svg%3E",
  };
  const endIcon = {
    url: "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='20' height='20' viewBox='0 0 20 20' fill='none'%3E%3Ccircle cx='10' cy='10' r='6' fill='%23FF0A38'/%3E%3Ccircle cx='10' cy='10' r='9' stroke='%23FF0A38' strokeWidth='2'/%3E%3C/svg%3E",
  };
  const refreshFun = () => {
    setIsLoader1(true);
    getpageContent();
    getorderTracing();
    handleViewOrder();
  };

  return (
    <div className="md:h-auto pb-4 pt-4 h-min-[500px]">
      {/* <Breadcrumbs /> */}
      {isLoader1 || isLoader2 ? (
        <Layout>
          <TrackFoodLoader className="h-auto" />
        </Layout>
      ) : (
        isLoader1 == false &&
        isLoader2 == false && (
          <Layout>
            <div>
              <div
                // md:h-[230px] mdl:h-[242px]
                // ${
                //   orderType == "Delivery" ? "h-[560px]" : "h-[490px]"
                // }
                className={`border border-gray-shade-13  w-full rounded-lg relative pb-5 h-auto md:pb-10 lg:pb-12
                
                `}
              >
                <div className="flex absolute top-2 right-2 text-end p-1 text-sm md:text-base justify-end mb-2	" style={{color: websiteColor}}>
                  <div
                    onClick={() => {
                      refreshFun();
                    }}
                    className="pr-[3px] cursor-pointer underline font-bold leading-normal	"
                  >
                    Refresh{" "}
                  </div>
                  <div
                    onClick={() => {
                      refreshFun();
                    }}
                    className="pt-[5px] cursor-pointer "
                  >
                    {" "}
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="16"
                      height="14"
                      viewBox="0 0 16 14"
                      fill="none"
                    >
                      <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M7.25601 0.0393603C6.85886 0.0855357 6.40695 0.181465 5.97945 0.310333C5.47621 0.462097 4.53496 0.930508 4.07471 1.25828C3.6203 1.58185 2.86106 2.33582 2.55477 2.76768C2.32774 3.08779 2.32389 3.09752 2.32389 3.35199C2.32389 3.5866 2.33466 3.62219 2.43933 3.73343C2.79703 4.11365 3.16594 4.02561 3.57705 3.46188C4.37108 2.37314 5.61393 1.59316 6.99138 1.31919C7.46449 1.22507 8.50978 1.22557 8.97947 1.32011C10.6959 1.66566 12.0792 2.69056 12.8673 4.20061C12.9811 4.41864 13.1268 4.75434 13.1912 4.94662C13.3146 5.31552 13.4389 5.84681 13.4087 5.87694C13.3989 5.88679 13.2654 5.79732 13.112 5.67811C12.9586 5.55894 12.7689 5.4422 12.6904 5.41865C12.311 5.30502 11.9245 5.59915 11.9245 6.00153C11.9245 6.30668 11.9609 6.34573 12.9635 7.11794C13.911 7.84774 14.1541 7.95522 14.4496 7.77506C14.5739 7.69925 15.8146 6.12286 15.9351 5.8876C16.138 5.49156 15.8403 5.03016 15.3843 5.03366C15.1448 5.03554 15.0238 5.10831 14.807 5.38094L14.6426 5.58765L14.5391 5.1693C14.1522 3.60561 13.3018 2.31223 12.0207 1.33912C10.7209 0.351776 8.88261 -0.14969 7.25601 0.0393603ZM1.57354 5.68415C1.47738 5.73218 1.24362 6.00461 0.756426 6.63645C0.381058 7.12321 0.0564061 7.57169 0.0349345 7.63303C-0.103707 8.0291 0.18716 8.43463 0.609819 8.43463C0.850816 8.43463 0.998501 8.34586 1.19906 8.08039L1.35821 7.86975L1.4394 8.21507C1.76563 9.6028 2.52972 10.8941 3.54669 11.7764C5.35373 13.3442 7.83389 13.8627 10.0662 13.1392C10.6078 12.9637 11.4646 12.5337 11.9245 12.2067C12.3785 11.8839 13.1378 11.1299 13.4445 10.6976C13.6715 10.3775 13.6754 10.3678 13.6754 10.1133C13.6754 9.87869 13.6646 9.8431 13.5599 9.73186C13.2023 9.35172 12.8336 9.43968 12.4218 10.0034C10.4528 12.6985 6.51304 12.9906 4.12766 10.6182C3.3755 9.87015 2.84529 8.90231 2.63184 7.88765C2.59929 7.73284 2.5809 7.59797 2.59094 7.58789C2.60102 7.57785 2.72412 7.65993 2.86457 7.77025C3.19372 8.02894 3.34795 8.09328 3.56185 8.06123C3.85591 8.01709 4.07471 7.76224 4.07471 7.46376C4.07471 7.15754 4.03065 7.11009 3.03576 6.3457C2.09128 5.61997 1.88699 5.52754 1.57354 5.68415Z"
                        fill={websiteColor}
                      />
                    </svg>
                  </div>
                </div>

                <div className="font-inter text-base md:text-lg font-semibold pt-5 pl-9 pb-9 md:pb-0 md:pt-4 md:pl-5 lg:pl-9 lg:pt-6 max-w-[70%] md:max-w-[80%] lg:max-w-[90%]">
                  {status?.storedetails?.store_Name}
                </div>
                {/* Desktop version */}
                <div className="hidden md:block md:ml-14 md:mr-14 mdl:ml-[100px] mdl:mr-24 ml-10">
                  {orderType == "Delivery" ? (
                    <ol className="md: mt-10 flex items-center w-full text-sm font-medium text-center text-gray-500  sm:text-base">
                      <li
                        className={`flex md:w-full items-center  dark:text-green-700 sm:after:content-[''] 
                        after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2  after:border-1 
                        after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0 dark:after:border-green-700 relative ${
                          orderProcessing >= 0
                            ? "text-green-700 "
                            : "text-gray-600 "
                        }
                        
                        ${
                          orderProcessing >= 1
                            ? " after:border-green-700"
                            : " after:border-gray-500"
                        }
                        
                        
                        `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden  after:mx-2 after:text-green-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex md:w-full items-center   sm:after:content-[''] 
                        after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2  after:border-1 
                        after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0
                          relative ${
                            orderProcessing >= 1
                              ? "text-green-700 "
                              : "text-gray-600 "
                          }
                         
                         ${
                           orderProcessing >= 2
                             ? " after:border-green-700"
                             : " after:border-gray-500"
                         }

                         
                         `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex md:w-full items-center  sm:after:content-[''] 
                      after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2 
                      after:border-1 after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0
                        relative ${
                          orderProcessing >= 2
                            ? "text-green-700 "
                            : "text-gray-600 "
                        }
                       ${
                         orderProcessing >= 3
                           ? " after:border-green-700"
                           : " after:border-gray-500"
                       }
                       
                       `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex md:w-full items-center   sm:after:content-[''] 
                    after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2  after:border-1 after:hidden sm:after:inline-block 
                    after:mx-6 after:md:mx-0 xl:after:mx-0  relative ${
                      orderProcessing >= 3 ? "text-green-700" : "text-gray-600 "
                    }
                    ${
                      orderProcessing == 4
                        ? " after:border-green-700"
                        : " after:border-gray-500"
                    }

                    `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex items-center ${
                          orderProcessing == 4
                            ? "text-green-700 after:border-green-700"
                            : "text-gray-600 after:border-gray-500"
                        }`}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-green-200 dark:after:text-green-700">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>
                    </ol>
                  ) : (
                    <ol className="md: mt-10 flex items-center w-full text-sm font-medium text-center text-gray-500  sm:text-base">
                      <li
                        className={`flex md:w-full items-center  dark:text-green-700 sm:after:content-[''] 
                    after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2  after:border-1 
                    after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0 dark:after:border-green-700 relative ${
                      orderProcessing >= 0
                        ? "text-green-700 "
                        : "text-gray-600 "
                    }
                    ${
                      orderProcessing >= 1
                        ? " after:border-green-700"
                        : " after:border-gray-500"
                    }
                    
                    `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden  after:mx-2 after:text-green-200 dark:after:text-green-700">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex md:w-full items-center   sm:after:content-[''] 
                    after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2  after:border-1 
                    after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0
                      relative ${
                        orderProcessing >= 1
                          ? "text-green-700 "
                          : "text-gray-600 "
                      }
                      ${
                        orderProcessing >= 2
                          ? " after:border-green-700"
                          : " after:border-gray-500"
                      }
                     
                     `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex md:w-full items-center  sm:after:content-[''] 
                  after:w-full after:xl:h-1 after:h-10 after:md:h-px after:border-b-2 
                  after:border-1 after:hidden sm:after:inline-block after:mx-6 after:md:mx-0 xl:after:mx-0
                   dark:after:border-green-700 relative ${
                     orderProcessing >= 2 ? "text-green-700 " : "text-gray-600 "
                   }
                   ${
                     orderProcessing == 3
                       ? " after:border-green-700"
                       : " after:border-gray-500"
                   }
                   `}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-gray-200 ">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   "
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>

                      <li
                        className={`flex items-center ${
                          orderProcessing >= 3
                            ? "text-green-700 after:border-green-700"
                            : "text-gray-600 after:border-gray-500"
                        }`}
                      >
                        <span className="flex items-center after:content-['/'] sm:after:hidden after:mx-2 after:text-green-200 dark:after:text-green-700">
                          <svg
                            className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                            aria-hidden="true"
                            xmlns="http://www.w3.org/2000/svg"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                          </svg>
                        </span>
                      </li>
                    </ol>
                  )}

                  {orderType == "Delivery" ? (
                    <div className="flex justify-between md:flex-row flex-col h-[325px] md:h-[0px] absolute top-16 left-[80px] md:relative md:top-0 md:left-0">
                      <div className="mt-4 ml-0">
                        <OrderPlaced
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 0 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4">
                        <OrderConfirmed
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 1 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4">
                        <OrderPreparing
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 2 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4">
                        <OutForDelivery
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 3 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4 mr-3">
                        <OrderDelivered
                          className={` md:w-7 md:h-7 ${
                            orderProcessing == 4 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                    </div>
                  ) : (
                    <div className="flex justify-between md:flex-row flex-col h-[325px] md:h-[0px] absolute top-16 left-[80px] md:relative md:top-0 md:left-0">
                      <div className="mt-4 ml-0">
                        <OrderPlaced
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 0 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4">
                        <OrderConfirmed
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 1 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                      <div className="mt-4">
                        <OrderPreparing
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 2 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>

                      <div className="mt-4 mr-3">
                        <OrderDelivered
                          className={` md:w-7 md:h-7 ${
                            orderProcessing >= 3 ? "fill-stepperCircle" : ""
                          }`}
                        />
                      </div>
                    </div>
                  )}
                </div>

                {orderType == "Delivery" ? (
                  <div className="hidden  md:flex justify-between md:ml-5 md:mr-6 mdl:ml-[72px] mdl:mr-[72px] md:flex-row flex-col h-[310px] md:h-[50px] absolute top-[105px] left-20 md:relative md:top-0 md:left-0 md:pt-14">
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium ml-[-11px] md:ml-[5px] md:mr-[5px] lg:ml-[-12px] lg:mr-[7px]   ${
                        orderProcessing >= 0 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Placed
                    </div>
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium  ${
                        orderProcessing >= 1 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Confirmed
                    </div>
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium  ${
                        orderProcessing >= 2 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Preparing
                    </div>
                    <div
                      className={`relative md:text-sm mdl:text-md font-inter font-medium pr-[20px]  ${
                        orderProcessing >= 3 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Out For Delivery
                      {orderProcessing == 3 &&
                      (!checkEmpty(status?.riderDetails?.rider_Name) ||
                        !checkEmpty(status?.riderDetails?.rider_Telephone)) ? (
                        <div
                          className={`absolute w-[370px]   left-[-130px] ${
                            !checkEmpty(status?.riderDetails?.rider_Name) &&
                            !checkEmpty(status?.riderDetails?.rider_Telephone)
                              ? "top-[-135px]"
                              : "top-[-115px]"
                          }`}
                        >
                          <div className="flex flex-row justify-center items-center	">
                            <div>
                              {!checkEmpty(status?.riderDetails?.rider_Name) ? (
                                <p className=" capitalize text-sm">
                                  {status?.riderDetails?.rider_Name}
                                </p>
                              ) : (
                                ""
                              )}
                              {!checkEmpty(
                                status?.riderDetails?.rider_Telephone
                              ) ? (
                                <p className="text-sm">
                                  {" "}
                                  {status?.riderDetails?.rider_Telephone}
                                </p>
                              ) : (
                                ""
                              )}
                            </div>
                            {!checkEmpty(
                              status?.riderDetails?.rider_Telephone
                            ) ? (
                              <div className="pl-1 relative">
                                <a
                                  className="cursor-pointer"
                                  href={`tel:${status?.riderDetails?.rider_Telephone}`}
                                >
                                  <svg
                                    width="28"
                                    height="28"
                                    viewBox="0 0 28 28"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                  >
                                    <g id="Frame 1000005889">
                                      <circle
                                        id="Ellipse 2850"
                                        cx="13.7535"
                                        cy="13.7535"
                                        r="13.7535"
                                        fill="#05B011"
                                      />
                                      <path
                                        id="Rectangle 77"
                                        d="M18.6189 17.5107V16.6924C18.6189 16.1826 18.3085 15.7241 17.8352 15.5348L16.9134 15.1661C16.3113 14.9252 15.6252 15.1861 15.3352 15.7661L15.2941 15.8483C15.2941 15.8483 13.9088 15.5712 12.8005 14.4629C11.6922 13.3547 11.4152 11.9693 11.4152 11.9693L11.4973 11.9283C12.0773 11.6383 12.3382 10.9521 12.0974 10.35L11.7287 9.42828C11.5393 8.95492 11.0809 8.64453 10.571 8.64453H9.75276C9.14068 8.64453 8.64449 9.14072 8.64449 9.7528C8.64449 14.6494 12.614 18.6189 17.5106 18.6189C18.1227 18.6189 18.6189 18.1228 18.6189 17.5107Z"
                                        stroke="white"
                                        strokeLinejoin="round"
                                      />
                                    </g>
                                  </svg>
                                </a>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      ) : (
                        ""
                      )}
                    </div>
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium md:mr-7 lg:mr-5  ${
                        orderProcessing == 4 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Delivered
                    </div>
                  </div>
                ) : (
                  <div className="hidden  md:flex justify-between md:ml-5 md:mr-6 mdl:ml-[72px] mdl:mr-[72px] md:flex-row flex-col h-[310px] md:h-[50px] absolute top-[105px] left-20 md:relative md:top-0 md:left-0 md:pt-14">
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium ml-[-11px] md:ml-[-5px] md:mr-[20px] lg:ml-[-12px] lg:mr-[7px] ${
                        orderProcessing >= 0 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Placed
                    </div>
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium  ${
                        orderProcessing >= 1 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Confirmed
                    </div>
                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium pr-[20px]  ${
                        orderProcessing >= 2 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Order Preparing
                    </div>

                    <div
                      className={`md:text-sm mdl:text-md font-inter font-medium relative md:mr-[5px] lg:mr-0 ${
                        orderProcessing >= 3 ? "text-stepperCircle" : ""
                      }`}
                    >
                      Delivered
                    </div>
                  </div>
                )}

                {/* Desktop version */}

                {/* mobile version */}

                <div className="block md:hidden md:ml-14 md:mr-14 mdl:ml-[100px] mdl:mr-24 ml-10">
                  {orderType == "Delivery" ? (
                    <ol className="relative text-gray-500">
                      <li
                        className={`mb-10 ms-6   ${
                          orderProcessing >= 0 ? "text-green-700" : ""
                        }`}
                      >
                        <p className="text-sm">
                          {" "}
                          <OrderPlaced
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 0 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3">
                          {" "}
                          Order Placed
                        </h3>

                        <div
                          className={` h-[79px] absolute left-0 top-[21px] border-l-[2px] 	${
                            orderProcessing >= 1
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[5px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4  ring-white  ">
                          <div>
                            <svg
                              className="flex-col w-4 h-4 sm:w-4 sm:h-4 me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                      </li>

                      <li
                        className={` mb-10 ms-6    ${
                          orderProcessing >= 1
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <div
                          className={` h-[86px] absolute left-0 top-[116px] border-l-[2px] 	    ${
                            orderProcessing >= 2
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>

                        <span className="absolute top-[100px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white  ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[-12px]">
                          {" "}
                          <OrderConfirmed
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 1 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base	mt-3 ">
                          {" "}
                          Order Confirmed
                        </h3>
                      </li>

                      <li
                        className={` mb-10 ms-6    ${
                          orderProcessing >= 2
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <div
                          className={` h-[86px] absolute left-0 top-[216px] border-l-[2px]  	    ${
                            orderProcessing >= 3
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[200px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[0px]">
                          {" "}
                          <OrderPreparing
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 2 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3	 ">
                          {" "}
                          Order Preparing
                        </h3>
                      </li>

                      <li
                        className={` mb-10 ms-6    ${
                          orderProcessing >= 3
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <div
                          className={` h-[86px] absolute left-0 top-[316px] border-l-[2px]  	    ${
                            orderProcessing == 4
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[300px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[0px]">
                          {" "}
                          <OutForDelivery
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 3 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base	mt-3 ">
                          {" "}
                          Out For Delivery
                        </h3>
                        {orderProcessing == 3 ? (
                          <div className="absolute top-[285px] left-[68px]">
                            <div className="flex items-center	">
                              <div>
                                {!checkEmpty(
                                  status?.riderDetails?.rider_Name
                                ) ? (
                                  <p className=" capitalize text-xs">
                                    {status?.riderDetails?.rider_Name}
                                  </p>
                                ) : (
                                  ""
                                )}
                                {!checkEmpty(
                                  status?.riderDetails?.rider_Telephone
                                ) ? (
                                  <p className="text-xs">
                                    {status?.riderDetails?.rider_Telephone}
                                  </p>
                                ) : (
                                  ""
                                )}
                              </div>

                              {!checkEmpty(
                                status?.riderDetails?.rider_Telephone
                              ) ? (
                                <div className="pl-1 pr-3 relative">
                                  <a
                                    className="cursor-pointer"
                                    href={`tel:${status?.riderDetails?.rider_Telephone}`}
                                  >
                                    <svg
                                      width="28"
                                      height="28"
                                      viewBox="0 0 28 28"
                                      fill="none"
                                      xmlns="http://www.w3.org/2000/svg"
                                    >
                                      <g id="Frame 1000005889">
                                        <circle
                                          id="Ellipse 2850"
                                          cx="13.7535"
                                          cy="13.7535"
                                          r="13.7535"
                                          fill="#05B011"
                                        />
                                        <path
                                          id="Rectangle 77"
                                          d="M18.6189 17.5107V16.6924C18.6189 16.1826 18.3085 15.7241 17.8352 15.5348L16.9134 15.1661C16.3113 14.9252 15.6252 15.1861 15.3352 15.7661L15.2941 15.8483C15.2941 15.8483 13.9088 15.5712 12.8005 14.4629C11.6922 13.3547 11.4152 11.9693 11.4152 11.9693L11.4973 11.9283C12.0773 11.6383 12.3382 10.9521 12.0974 10.35L11.7287 9.42828C11.5393 8.95492 11.0809 8.64453 10.571 8.64453H9.75276C9.14068 8.64453 8.64449 9.14072 8.64449 9.7528C8.64449 14.6494 12.614 18.6189 17.5106 18.6189C18.1227 18.6189 18.6189 18.1228 18.6189 17.5107Z"
                                          stroke="white"
                                          strokeLinejoin="round"
                                        />
                                      </g>
                                    </svg>
                                  </a>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        ) : (
                          ""
                        )}
                      </li>

                      <li
                        className={` ms-6    ${
                          orderProcessing == 4
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <span className="absolute top-[400px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[0px]">
                          {" "}
                          <OrderDelivered
                            className={` md:w-7 md:h-7   ${
                              orderProcessing == 4 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3">
                          {" "}
                          Delivered
                        </h3>
                      </li>
                    </ol>
                  ) : (
                    <ol className="relative text-gray-500">
                      <li
                        className={`mb-10 ms-6   ${
                          orderProcessing >= 0 ? "text-green-700" : ""
                        }`}
                      >
                        <p className="text-sm">
                          {" "}
                          <OrderPlaced
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 0 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3">
                          {" "}
                          Order Placed
                        </h3>

                        <div
                          className={` h-[79px] absolute left-0 top-[21px] border-l-[2px] 	${
                            orderProcessing >= 1
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[5px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4  ring-white">
                          <div>
                            <svg
                              className="flex-col w-4 h-4 sm:w-4 sm:h-4 me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                      </li>

                      <li
                        className={` mb-10 ms-6    ${
                          orderProcessing >= 1
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <div
                          className={` h-[86px] absolute left-0 top-[116px] border-l-[2px] 	    ${
                            orderProcessing >= 2
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[100px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[-12px]">
                          {" "}
                          <OrderConfirmed
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 1 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3	 ">
                          {" "}
                          Order Confirmed
                        </h3>
                      </li>

                      <li
                        className={` mb-10 ms-6    ${
                          orderProcessing >= 2
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <div
                          className={` h-[86px] absolute left-0 top-[216px] border-l-[2px]  	    ${
                            orderProcessing == 3
                              ? "border-green-700"
                              : "border-gray-500"
                          }`}
                        ></div>
                        <span className="absolute top-[200px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[0px]">
                          {" "}
                          <OrderPreparing
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 2 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3	 ">
                          {" "}
                          Order Preparing
                        </h3>
                      </li>

                      <li
                        className={` ms-6    ${
                          orderProcessing >= 3
                            ? "text-green-700"
                            : "text-gray-600"
                        }`}
                      >
                        <span className="absolute top-[300px] left-[-11px] flex items-center justify-center w-8 h-4  rounded-full -start-4 ring-white ">
                          <div>
                            <svg
                              className="w-3.5 h-3.5 sm:w-4 sm:h-4 md:w-7 md:h-7   me-2.5"
                              aria-hidden="true"
                              xmlns="http://www.w3.org/2000/svg"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10 .5a9.5 9.5 0 1 0 9.5 9.5A9.51 9.51 0 0 0 10 .5Zm3.707 8.207-4 4a1 1 0 0 1-1.414 0l-2-2a1 1 0 0 1 1.414-1.414L9 10.586l3.293-3.293a1 1 0 0 1 1.414 1.414Z" />
                            </svg>
                          </div>
                        </span>
                        <p className="text-sm mt-[0px]">
                          {" "}
                          <OrderDelivered
                            className={` md:w-7 md:h-7   ${
                              orderProcessing >= 3 ? "fill-stepperCircle" : ""
                            }`}
                          />
                        </p>
                        <h3 className="font-medium leading-tight text-base mt-3">
                          {" "}
                          Delivered
                        </h3>
                      </li>
                    </ol>
                  )}
                </div>

                {/* mobile version */}
              </div>

              <div className="md:mt-4 mdl:mt-7 flex  gap-3 md:gap-3  md:flex-row flex-col  h-auto md:h-full mb-3 ">
                <div
                  className="min-h-44  lg:pb-4 h-auto md:w-[34%] bg-white-shade-4 rounded-lg mdl:py-5 mdl:px-4   md:pb-5 mdl:pb-0 mt-7 md:mt-0 p-3 
                  pt-7 pl-7
                  md:pt-7 md:pl-4
                  lg:pt-7 lg:pl-8"
                >
                  <div className="text-xs font-inter font-semibold text-gray-shade-14  ">
                    {status?.basket?.pos_basket_Delivery_Type == "Delivery"
                      ? " Delivery Information"
                      : "Order Collection Information"}
                  </div>
                  <div className="mt-6 text-[19px] font-inter font-semibold  mb-[10px] ">
                    {status?.basket?.pos_basket_Delivery_Type == "Delivery"
                      ? status?.basket?.pos_basket_Customer_First_Name
                      : status?.storedetails?.store_Name}
                  </div>
                  <div className="text-[14px] font-inter font-normal text-gray-shade-15 mt-[5px] mb-4 capitalize">
                    {status?.basket?.pos_basket_Delivery_Type == "Delivery"
                      ? prepareAddressFormat(
                          status?.basket
                            ?.pos_basket_Customer_Billing_Address_Line_1,
                          status?.basket
                            ?.pos_basket_Customer_Billing_Address_Line_2,
                          status?.basket?.pos_basket_Customer_Billing_City,
                          removeAllSpaceFromString(
                            status?.basket?.pos_basket_Customer_Billing_Postcode
                          )
                        )
                      : prepareAddressFormat(
                          status?.storedetails?.store_Address_Line_1,
                          status?.storedetails?.store_Address_Line_2,
                          status?.storedetails?.store_City,
                          removeAllSpaceFromString(
                            status?.storedetails?.store_Postcode
                          )
                        )}
                    {!checkEmpty(
                      status?.basket?.pos_basket_Customer_Telephone
                    ) &&
                    status?.basket?.pos_basket_Delivery_Type == "Delivery" ? (
                      <p>
                        {addLeadingZero(
                          status?.basket?.pos_basket_Customer_Telephone
                        )}
                      </p>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <div className=" lg:pb-4 h-auto md:w-[34%] bg-white-shade-4  rounded-lg mdl:py-5 mdl:px-4  md:pr-3  md:pb-5 mdl:pb-0  ml-0 p-7 md:pt-7  md:pl-3 lg:pt-7  lg:pl-10 ">
                  <div className="text-xs font-inter text-gray-shade-14   font-bold	">
                    Instructions
                  </div>
                  {checkEmpty(status?.basket?.pos_basket_Customer_Note) && (
                    <div
                      className="w-full h-[95%] text-sm	pt-4  text-balance text-left    
                    font-inter font-semibold text-black flex justify-start items-start break-all"
                    >
                      No cooking instruction
                    </div>
                  )}

                  {!checkEmpty(status?.basket?.pos_basket_Customer_Note) && (
                    <div className="pt-4 text-sm	text-black font-bold break-all">
                      {status?.basket?.pos_basket_Customer_Note}
                    </div>
                  )}
                </div>
                <div className="min-h-44 md:h-auto md:w-[32%]  bg-white-shade-4  rounded-lg  mdl:pt-0  mdl:pb-0 flex h-[140px]  ml-0 m-0 p-0">
                  <div className="w-[49%] flex flex-col items-center h-full justify-center ">
                    <div className="">
                      <TrackOrderId className="h-[46px] w-[46px] md:h-[40px] md:w-[40px] lg:h-[46px] lg:w-[46px]" />
                    </div>
                    <div className=" mdl:text-md font-semibold font-inter mt-3 text-base md:mt-3 md:text-sm	">
                      Order Id
                    </div>
                    <div className="md:text-xs mdl:text-sm font-normal font-inter text-dark-shade-8 text-center text-sm		">
                      #{status?.basket?.pos_basket_Id}
                    </div>
                  </div>
                  <div className="border-l-[1px] border-border-shade-5  mdl:-ml-0 mt-5 mb-5 "></div>
                  <div className="w-[50%] flex flex-col h-full justify-center items-center">
                    <div className="">
                      <TrackPaymentMode className="h-[46px] w-[46px] md:h-[40px] md:w-[40px] lg:h-[46px] lg:w-[46px]" />
                    </div>
                    <div className=" mdl:text-md font-semibold font-inter text-center mt-3 text-base md:mt-[10px]	md:text-sm">
                      Payment Mode
                    </div>
                    <div className="md:text-xs mdl:text-sm font-normal font-inter text-dark-shade-8 text-center text-sm		">
                      {status?.basket?.pos_basket_Payment_Type == "Card"
                        ? "Card"
                        : "Cash on Delivery"}
                    </div>
                  </div>
                </div>
              </div>

              <div className={`flex  flex-col  md:flex-row   `}>
                <div className="md:w-1/2 w-full h-[400px] bg-white-shade-4 rounded-lg md:h-[600px]">
                  <TrackMap
                    defaultCenter={defaultCenter}
                    pathCoordinates={pathCoordinates}
                    start={start}
                    end={end}
                  />
                </div>
                <div className="md:w-1/2 w-full h-auto flex flex-col mt-[220px] md:mt-0 md:max-h-[600px] md:overflow-scroll md:no-scrollbar">
                  {orderDetails && (
                    <OrderModal
                      formWhere="1"
                      toggleDrawer={toggleDrawer}
                      orderDetails={orderDetails}
                      basketStoreDetails={basketStoreDetails}
                    />
                  )}
                </div>
              </div>
            </div>
          </Layout>
        )
      )}
    </div>
  );
};

export default TrackFood;
